export function formatCurrency (currency: number) {
  return ((currency || 0) / 100).toFixed(2)
}
